/**
 * ============================================================================
 * EXECUTIVE SUMMARY API — glossary only.
 * ============================================================================
 *
 * LAYER: cache policy. The glossary backend endpoint does not exist yet, so
 * the endpoint is served from the local fixture via queryFn — NO transport.
 * When the backend ships it: add accessors/GetGlossaryApi.ts (extends
 * ReportingApiClient) and delegate here, same pattern as metricsApi.
 *
 * HISTORY: this file previously declared getData/getViews/getRefreshStatus
 * endpoints for a backend design that was superseded by
 * getMetrics — they had zero consumers and pointed at endpoints that were
 * never built, so they were removed (see spec fe5, refactor tasks).
 */

import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { GlossaryResponse } from 'src/types';

export const executiveSummaryApi = createApi({
  reducerPath: 'executiveSummaryApi',
  baseQuery: fakeBaseQuery<{ status: number; data: unknown }>(),
  keepUnusedDataFor: Infinity,
  endpoints: (builder) => ({
    // TODO(backend): replace fixture with accessors/GetGlossaryApi once the
    // endpoint exists (metric_technical_definitions + glossary tables).
    getGlossary: builder.query<GlossaryResponse, void>({
      queryFn: async () => {
        const { mockGlossaryData } = await import('src/mocks/glossaryFixture');
        return { data: mockGlossaryData };
      },
    }),
  }),
});

export const { useGetGlossaryQuery } = executiveSummaryApi;
